export class Errors {
  static getMessage(error: any, def?: string): string {
    if (error && error.rejection && error.rejection.error && error.rejection.error.message) {
      return error.rejection.error.message;
    }
    if (error && error.error && error.error.message) {
      return error.error.message;
    }
    if (error && error.message) {
      return error.message;
    }
    return def || 'Wystąpił błąd';
  }

}

